// src/pages/Appli/AppliAdmin/Prospects/components/InlineProspectStatutSelect.jsx
import React from "react";

const tones = {
  "Nouveau Prospect": "bg-blue-100 text-blue-800",
  "A Recontacter": "bg-violet-100 text-violet-800",
  "Contacté & en attente": "bg-amber-100 text-amber-800",
  "Prospect Qualifié": "bg-orange-100 text-orange-800",
  "En Test": "bg-green-100 text-green-800",
  "Client": "bg-emerald-100 text-emerald-800",
  "Client SAAS": "bg-teal-100 text-teal-800",
  "Perdu": "bg-red-100 text-red-800",
};

export function InlineProspectStatutSelect({ value = "", onChange, options = [], size = "md" }) {
  const cls = size === "sm" ? "text-xs px-2 py-1" : "text-xs px-2.5 py-1.5";
  return (
    <select
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      className={`rounded ${cls} ${tones[value] || "bg-slate-100 text-slate-700"}`}
    >
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
    </select>
  );
}
